module.exports = __webpack_public_path__ + "img/sppr_0602.bf688aff.jpg";